module.exports = __webpack_public_path__ + "static/5-star-wealth-manager-michael-mueller-d145f7e60de3f48332f2ff776c0befbb.jpg";